import React, {Component} from 'react';
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import {FaInfo, FaTrash} from "react-icons/fa";
import {Link} from "react-router-dom";

class ListTicketComponent extends Component {

    loadStatus = () => {
        if ( this.props.ticket.status === 'Pending' ) {
            return (
                <span className="text-warning">
                    Đang chờ xử lý
                </span>
            )
        }
        else if (this.props.ticket.status === 'Done') {
            return (
                <span className="text-success">
                    Đã xử lý xong
                </span>
            );
        }
        else if (this.props.ticket.status === 'Processing') {
            return (
                <span className="text-info">
                    Đang xử lý
                </span>
            );
        }
        else if (this.props.ticket.status === 'Cancel') {
            return (
                <span className="text-danger">
                    Đã hủy
                </span>
            );
        }
    }

    render() {
        return (
            <tr>
                <td>#{ this.props.ticket.id }</td>
                <td>{ this.props.ticket.title }</td>
                <td>{ this.props.ticket.content }</td>
                <td>{ this.loadStatus() }</td>
                <td>{ this.props.ticket.text_created_at }</td>
                <td>
                    <OverlayTrigger
                        delay={{ hide: 450, show: 300 }}
                        overlay={(props) => (
                            <Tooltip {...props}>
                                Chi tiết
                            </Tooltip>
                        )}
                        placement="top"
                    >
                        <Link className="btn btn-warning btn-sm mr-1 text-light" to={"/ho-tro/" + this.props.ticket.id + "/chi-tiet-ho-tro.html"}>
                            <FaInfo />
                        </Link>
                    </OverlayTrigger>
                    <OverlayTrigger
                        delay={{ hide: 450, show: 300 }}
                        overlay={(props) => (
                            <Tooltip {...props}>
                                Hủy hổ trợ
                            </Tooltip>
                        )}
                        placement="top"
                    >
                        <button type="button" className="btn btn-danger btn-sm mr-1" onClick={ () => this.props.showModal( this.props.actionKey, 'delete' ) }>
                            <FaTrash />
                        </button>
                    </OverlayTrigger>
                </td>
            </tr>
        );
    }
}

export default ListTicketComponent;